<template>
  <v-container fluid class="down-top-padding" v-if='ready'>
    <!-- <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb> -->
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please Wait....
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12" sm="12">

        <BaseCard class="strong" heading="Programs List">
        <div style='max-width:300px;'>
          <v-select
          :disabled='$root.isLga'
          :items="lgasAll"
          item-text="name"
          v-model='selectedLga'
          :label="(selectedLga) ? selectedLga : 'LGA' "
          outlined
          dense
        >
        <template v-slot:prepend-item>
        <v-list-item
          ripple
          @click="selectedLga = false"
        >Reset
        </v-list-item>
        </template>
        </v-select>
                <v-btn v-if='!$root.isLga' color="primary" style='float:left;' @click='addProgram'>Add New Program</v-btn>
        </div>
          <div class="mt-4">
      <v-data-table :headers="headers" :items="programsSet" sort-by="Date" :sort-desc='true'>
        <template v-slot:item.Date="{ item }">
    <span>{{ new Date(item.Date).toLocaleDateStrinsg() }}</span>
  </template>
  <template v-slot:item.Logged="{ item }">
    <span v-if='item.Logged'> <b class='green-text'>Logged</b> </span>
    <span v-else> Not Logged </span>
  </template>
        <template v-slot:top>
          <v-toolbar flat color="white">
            <div style='position:absolute;right:10px;' v-if='$root.selectedLga == null'>
            <v-select :items="items" label="Filter" outlined  v-model='slFilter' class='mt-5' style='max-width:220px;'> </v-select>
            </div>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">

              <v-card>
                

                <v-card-text>
                  <v-container>
                    <h2 v-if='action == "Edit"'> Edit Program</h2>
                    <h2 v-if='action == "Create"'> Create Program</h2>
                    <v-row>
                      <v-col cols="12" >
                        <v-text-field v-model="editedItem['Program Name']" label="Program Name"></v-text-field>
                      </v-col>
                      
                      <v-col cols="12" >
                        <v-select
                       :disabled='$root.isLga'
                        :items="lgasAll"
                        item-text="name"
                        v-model='editedItem.LGA'
                        :label="(editedItem.LGA) ? editedItem.LGA : 'LGA' "
                        outlined
                        dense
                      ></v-select>
                      </v-col>

                      <v-col cols="12" >
                        <v-text-field v-model="editedItem.Description" label="Description"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                  <p class="red--text"
                  v-if='validate'
                  >Each Value Required Minimum 5 Characters</p>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                  <v-btn color="blue darken-1" v-if='action == "Edit"'
                  :disabled='validate'
                    text @click="save">Save</v-btn>
                  <v-btn color="blue darken-1" text v-if='action == "Create"'
                    :disabled='validate'
                   @click="saveProgram">Save</v-btn>
                 
                </v-card-actions>
                 
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }" v-if='!$root.isLga'>
          <v-icon  medium class="mr-2" @click="editItem(item)">mdi-archive-eye</v-icon>
          <v-icon medium @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
      <div>
      </div>
    </div>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';
export default {
  name: "Programs",
    computed:{ ...mapState(['programs','lgasAll']),
        programsSet() {
        if(this.selectedLga){
          let data = [];
          this.programs.forEach(element => {
            if(element.LGA === this.selectedLga) data.push(element)
          });
          return data;
        }else{
          return this.programs
        }
      },
      validate() {
        if(this.editedItem["LGA"].length < 5
        || this.editedItem["Program Name"].length < 1)
        {
          return true
        }else{
          return false
        }
      }
    },
  data: () => ({
    selectedLga:false,
    action:"Edit",
    loading:false,
      editedItem:{
        "LGA":'',
        "Program Name":'',
        "Description":'',
      },
    page: {
      title: "Programs"
    },
    sortBy: '',
    ready:false,
    sortDesc: false,
    slFilter:"",
    items: ['Clear'],
    dialog: false,
    editedIndex:0,
    headers: [
      {
        text: "Program Name",
        align: "start",
        sortable: true,
        value: "Program Name"
      },
      { text: "LGA", value: "LGA" },
      {
        text: "Description",
        align: "start",
        sortable: false,
        value: "Description"
      },
      { text: "Actions", value: "actions", sortable: false }
    ],
  }),
  methods:{
      addProgram() {
        this.action = "Create"
        this.editedItem['Program name'] = ''
        this.editedItem['Description'] = '' 
        this.editedItem['LGA'] = (this.$root.isLga) ? this.$root.user.LGA : '' 
        this.dialog = true;
      },
      async saveProgram() {
        this.loading = true;
        let programs = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Programs");
        await programs.push({
         "Program Name": this.editedItem['Program Name'],
         "LGA": this.editedItem['LGA'],
         "Description": this.editedItem['Description'],
        })
        this.editedItem = {
        "LGA":'',
        "Program Name":'',
        "Description":'',
      }
      this.dialog = false
      this.loading = false

      },
      close() {
          this.dialog = false;
      setTimeout(() => {
        this.editedItem = {
        "LGA":'',
        "Program Name":'',
        "Description":'',
      }
        this.editedIndex = -1;
      }, 300);
      },
      async save() {
        console.log(this.editedItem)
         this.loading = true;
        let programs = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Programs/"+this.editedItem.id);
        await programs.set({
         "Program Name": this.editedItem['Program Name'],
         "LGA": this.editedItem['LGA'],
         "Description": this.editedItem['Description'],
        })
        this.editedItem = {
        "LGA":'',
        "Program Name":'',
        "Description":'',
      }
      this.dialog = false
      this.loading = false
      },
      editItem( index ) {
        this.action = "Edit"
        this.editedIndex = this.programs.indexOf(index);
        let item =  this.programs[this.editedIndex];
        this.editedItem.id = item.id ; 
        this.editedItem['Program Name'] = item['Program Name']; 
        this.editedItem['Description'] = item['Description']; 
        this.editedItem['LGA'] = item['LGA']; 
        this.dialog = true;

      },
      deleteItem(item) {
        console.log(item)
      const index = this.programs.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.programs.splice(index, 1);
        let programs = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Programs/"+item.id);
        programs.remove()
    },
      fail(error) {
          console.log(error)
      }
  },
  watch: {
    '$root.isLga'(value) {
      if(value) this.selectedLga = this.$root.user.LGA
    },
    dialog(val) {
      val || this.close();
    },
  },  
  mounted() {
      if(this.$root.isLga){
      this.selectedLga = this.$root.user.LGA
      this.ready = true
      }else{
        this.ready = true
          //nothing
      }     
      setTimeout(() => {
      this.$root.loading = false
      }, 2000);
  }
};
</script>
